<template>
    <div class="quote">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>报价单管理</el-breadcrumb-item>-->

<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="商品编码">
                        <el-input v-model="searchForm.itemSku" placeholder="商品编码" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品名称">
                        <el-input v-model="searchForm.itemName" placeholder="商品名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="报价截止日期">
                    <el-date-picker v-model="searchForm.timeDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                                    end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" size="mini" clearable>
                    </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="状态">
                        <el-select v-model="searchForm.process" placeholder="状态" size="mini" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未报价" value="0"></el-option>
                            <el-option label="已出价" value="1"></el-option>
                            <el-option label="已报价" value="2"></el-option>
                            <el-option label="待发货" value="3"></el-option>
                            <el-option label="已发货" value="4"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                        <!-- <el-button type="primary" @click="handleExport" size="mini">条件导出</el-button> -->
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                 <el-table stripe
                    :data="tableData"
                    size="mini"
                    ref="detailTable"
                    v-loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%">
                     <el-table-column type="selection" width="55"/>
                     <el-table-column v-if="$store.state.userInfo.review"
                             prop="name"
                             label="供应商"
                             width="100"
                             fixed="left"
                     >
                     </el-table-column>
                        <el-table-column
                            prop="itemSku"
                            label="商品编码"
                            width="100"
                            fixed="left"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="itemName"
                            label="商品名称"
                            width="300"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="itemNum"
                            label="商品数量"
                            width="80"
                        >
                        </el-table-column>

                        <el-table-column
                            prop="itemUnit"
                            label="商品单位"
                            width="80"
                            >
                        </el-table-column>
                        <el-table-column
                                prop="price"
                            width="150"
                                label="商品报价单价(元)">
                        </el-table-column>
                        <el-table-column
                                prop="totalPrice"
                            width="150"
                                label="商品总报价(元)">
                        </el-table-column>
                        <el-table-column
                                prop="deadline"
                                label="报价截止日期" width="150" align="center">
                        </el-table-column>
                     <el-table-column
                             prop="sendDay"
                             label="货期(天)"
                             width="100"
                             align="center"/>
                     <el-table-column
                             prop="expireTime"
                             label="价格有效期"
                             width="120"
                             align="center"
                     />
                        <el-table-column
                            prop="remark"
                            width="300"
                            label="备注">
                        </el-table-column>
                        <el-table-column
                             prop="status"
                             label="状态"
                             width="100" align="center" fixed="right">
                         <template slot-scope="scope" >
                             <el-tag v-if="scope.row.orderId != null">中标</el-tag>
                             <el-tag v-if="scope.row.qstatus == 0 &&scope.row.orderId == null">未报价</el-tag>
                             <el-tag v-if="scope.row.qstatus == 1 && scope.row.orderId == null">出价</el-tag>
                             <el-tag v-if="scope.row.qstatus == 2 && scope.row.orderId == null">已报价</el-tag>
                             <el-tag v-if="scope.row.qstatus == 3 && scope.row.orderId == null">已放弃</el-tag>
                         </template>
                     </el-table-column>
                     <el-table-column
                             prop="status"
                             label="货物状态"
                             width="100" align="center" fixed="right">
                         <template slot-scope="scope" >
                             <span>{{scope.row.status==0?'未发货':(scope.row.status==1?'已发货':(scope.row.status==2?'已发货':'-')) }}
                             </span>

                         </template>
                     </el-table-column>

                    <el-table-column label="操作" width="250" align="center" fixed="right">
                        <template slot="header">

<!--                            <el-button type="primary"   size="mini" @click="onSubmitPrice">提交报价</el-button>-->

                        </template>
                        <template slot-scope="scope">
                            <el-button type="text"
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)" :disabled=" scope.row.qstatus == 3 || scope.row.qstatus == 2 || scope.row.orderId != null ||
                            new Date(Date.parse(scope.row.deadline.replace(/-/g, '/')))< new Date()">报价</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button v-if="scope.row.status == null && scope.row.qstatus <= 1 &&
                            new Date(Date.parse(scope.row.deadline.replace(/-/g, '/'))) > new Date()"
                                       type="text"   size="mini" @click="onSubmitPrice(scope.row)">提交报价</el-button>
                            <el-divider direction="vertical" v-if="scope.row.status == null && scope.row.qstatus <= 1 &&
                            new Date(Date.parse(scope.row.deadline.replace(/-/g, '/'))) > new Date()"></el-divider>
                            <el-button type="text"
                                    size="mini"
                                    @click="quit(scope.row)" :disabled=" scope.row.qstatus == 3 || scope.row.qstatus == 2 || scope.row.orderId != null ||
                            new Date(Date.parse(scope.row.deadline.replace(/-/g, '/')))< new Date()">放弃</el-button>
                            <el-divider direction="vertical" v-if="scope.row.status == 0 " ></el-divider>
                            <el-button  v-if="scope.row.status == 0 "
                                    size="mini" type="text"
                                    @click="handleDeliver(scope.row.id, scope.row.orderId)">发货</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

        <el-dialog title="商品报价信息导入" :visible.sync="importDialogVisible" width="500px">
            <el-form :model="editForm" label-width="80px">
                <el-form-item label="上传报价文件">
                    <el-upload
                            action="/api/admin/uploadFile"
                            accept=".xlsx"
                            :limit="1"
                            :before-upload="beforeUploadFile"
                            :on-change="fileChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList">
                        <el-button size="small" plain>选择文件</el-button>
                        <div slot="tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
                    </el-upload>
                    <el-input v-model="editForm.filePath" v-show="false" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onUploadSubmit">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="商品发货" :visible.sync="deliverDialogVisible" width="500px">
            <el-form :model="deliverForm" label-width="80px">
                <el-form-item label="备注">
                    <el-input v-model="deliverForm.memo" placeholder="请输入备注，如：运单号" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="deliverDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onDeliver">确 定</el-button>
            </div>
        </el-dialog>



        <el-dialog title="报单价信息" :visible.sync="editSupplierVisible" width="500px" close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
                <el-form-item label="商品编码">
                    <el-input v-model="editForm.itemId" :disabled="true" placeholder="请输入商品编码" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="editForm.itemName" :disabled="true"  placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品规格">
                    <el-input v-model="editForm.itemSpecification" :disabled="true"  placeholder="请输入商品规格" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品单位">
                    <el-input v-model="editForm.itemUnit" :disabled="true"  placeholder="请输入商品单位" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品数量">
                    <el-input v-model="editForm.itemNum" :disabled="true"  placeholder="请输入商品数量" clearable></el-input>
                </el-form-item>

                <el-form-item label="商品报价" prop="answerPrice">
                    <el-input v-model="editForm.answerPrice" placeholder="请输入商品报价" clearable></el-input>
                </el-form-item>
                <el-form-item label="失效时间" prop="expireTime">
                    <el-date-picker
                            v-model="editForm.expireTime"
                            type="date"
                            placeholder="报价失效时间" value-format="yyyy-MM-dd"
                            clearable
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="货期" prop="sendDay">
                    <el-input v-model="editForm.sendDay" type="number"  placeholder="?日内发货" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="editForm.remark" placeholder="请输入备注" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editSupplierVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {
                itemSku: "",
                itemName: "",
                timeDate: "",
                process: "",
            },
            pickerOptions: {

            },
            fileList: [],
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            importDialogVisible: false,
            editForm: {
                rfqId: "",
                profitRate: "",//利润率
                id: "",
                orderId: "",
                userId: null,
                itemId: "",
                itemName: "",
                itemPrice: "",
                answerPrice: "",
                itemSpecification: "",
                itemNum: "",
                itemUnit: "",
                remark: "",
                filePath: "",
                expireTime: "",
                sendDay: "",
            },
            deliverForm: {
                orderId: "",
                quoteId: "",
                memo: "",
            },
            staffs: [],//可选的派发的供应商

            editSupplier: false,
            editSupplierVisible: false,
            deliverDialogVisible: false,

            rules: {
                answerPrice: [
                    { required: true, message: '请输入商品报价', trigger: 'blur' }
                ],
                expireTime: [
                    { required: true, message: '请选择价格有效期', trigger: 'blur' }
                ],
                sendDay: [
                    { required: true, message: '请输入货期', trigger: 'blur' }
                ],
            },
        }
    },

    methods: {
        onSearch() {
            let url = "/admin/rfq/rfqdetail/supplier/search";
            let rfq = {
            };

            if(this.searchForm.itemSku != "") {
                rfq["itemSku"] = this.searchForm.itemSku;
            }
            if(this.searchForm.itemName != "") {
                rfq["itemName"] = this.searchForm.itemName;
            }
            if(this.searchForm.timeDate != "" &&this.searchForm.timeDate!=null) {
                rfq["startTime"] = this.searchForm.timeDate[0];
                rfq["endTime"] = this.searchForm.timeDate[1];
            }

                this.loading = true;
                let _this = this
                this.$axios.post(url,{
                    cond: rfq,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function() {
                });

        },
        handleCreate() {
            this.editForm.rfqId= this.rfqId;
            this.editForm.itemId = "";
            this.editForm.itemPrice = "";
            this.editForm.itemName = "";
            this.editDialogVisible = true;
        },
        handleCreateImport() {
            this.editForm.agreementId= this.agreementId;
            this.importDialogVisible = true;
        },

        onUploadSubmit() {
            let _this = this;
            this.$axios.post("/admin/rfq/rfqdetail/onUploadSubmit", this.editForm)
            .then(function(response){
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.importDialogVisible = false;
                    _this.onSearch();
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.quoteId = row.quoteId;
            this.editForm.rfqId = row.rfqId;
            this.editForm.itemId = row.itemId;
            this.editForm.itemName = row.itemName;
            this.editForm.itemNum = row.itemNum;
            this.editForm.itemUnit = row.itemUnit;
            this.editForm.itemPrice = row.itemPrice;
            this.editForm.itemSpecification = row.itemSpecification;
            this.editForm.price = row.price;
            this.editForm.totalPrice = row.totalPrice;
            this.editForm.remark = row.remark;
            this.editSupplierVisible = true;
            this.editForm.answerPrice = row.price;
            this.editForm.expireTime = row.expireTime;
            this.editForm.sendDay = row.sendDay;
        },
        handleExport() {
            let url = "/api/admin/rfq/exportGoods";
            window.open(url, "_blank");
        },
        // 文件状态改变时的钩子
        fileChange(file) {
            this.editForm.file = file.raw
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {
            let extension = file.name.substring(file.name.lastIndexOf('.')+1)
            let size = file.size / 1024 / 1024
            if(extension !== 'xlsx') {
                this.$notify.warning({
                    title: '警告',
                    message: `只能上传Excel2017（即后缀是.xlsx）的文件`
                });
            }
            if(size > 10) {
                this.$notify.warning({
                    title: '警告',
                    message: `文件大小不得超过10M`
                });
            }
        },
        // 文件上传成功时的钩子
        handleSuccess(res, file) {
            this.$notify.success({
                title: '成功',
                message: `文件上传成功`
            });
            if (file.response.data.success) {
                this.editForm.filePath = file.response.data.message; //将返回的文件储存路径赋值picture字段
            }
        },
        // 文件上传失败时的钩子
        handleError() {
            this.$notify.error({
                title: '错误',
                message: `文件上传失败`
            });
        },
        goBack() {
            this.$router.go(-1);

        },
        onSubmitPrice(row) {//提交报价
           // let arr = this.$refs.detailTable.selection;
            let arr = [row];
            if(arr.length == 0) {
                this.$notify.warning({
                    title: '提示',
                    message: "请先勾选报价单"
                });
                return;
            }
            for(let i=0; i<arr.length; i++){
                if(arr[i].price == null){
                    this.$notify.warning({
                        title: '提示',
                        message: "请先出价"
                    });
                    return;
                }
            }

            let _this = this;
            this.$confirm('是确认提交报价信息？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.post("/admin/quote/updateQuote",{list:arr,status:2} )
                    .then(function(response) {
                        let resp = response.data;
                        if(resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '提交报价成功',
                                type: 'success'
                            });
                            _this.checkQuote(row.id);
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        quit(row) {//放弃报价

            let arr = [row];


            let _this = this;
            this.$confirm('是确认放弃报价？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.post("/admin/quote/updateQuote",{list:arr,status:3} )
                    .then(function(response) {
                        let resp = response.data;
                        if(resp.header.status === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '已放弃',
                                type: 'success'
                            });
                            _this.checkQuote(row.id);
                            _this.onSearch();
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
            })
        },
        checkQuote(id) {
            this.$axios.post("/admin/quote/checkQuote",{id} )
            .then(function() {
            });
        },
        handleClose() {},

        onSend() {

            let that = this;
            let rfqDetailList = [];
            let arr = this.$refs.detailTable.selection;//选中的询价单列表
            for(let i=0; i<arr.length; i++){
                rfqDetailList.push(arr[i].id);
            }

            this.$axios.post("/admin/rfq/askSend",{
                rfqId: this.rfqId,
                details: rfqDetailList,//询价单明细id列表
                staffId: this.editForm.sendId,
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '派发询价单成功',
                        type: 'success'
                    });
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
                that.editSupplier = false;
            })
        },

        onSubmit() {
           this.$refs.editForm.validate(valid => {
                if (valid) {
                    let url = "/admin/quote/saveQuote";
                    let postData ={list: [{id:this.editForm.id,sendDay:this.editForm.sendDay,
                                answerPrice:this.editForm.answerPrice,
                                expireTime:this.editForm.expireTime,remark:this.editForm.remark}]};

                    let _this = this;
                    this.$axios.post(url, postData)
                        .then(function(response){
                            let resp = response.data;
                            if(resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.editDialogVisible = false;
                                _this.editSupplierVisible = false;
                                _this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            });

        },
        handleDeliver(quoteId,orderId) {
            this.deliverForm = {
                quoteId,
                orderId,
                memo: "",
            };
            this.deliverDialogVisible = true;
        },
        onDeliver() {//发货

            let _this = this;
            this.$confirm('是否确认发货？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.post("/admin/order/deliver",{
                    orderDetailIds: [_this.deliverForm.orderId],
                    quoteId: _this.deliverForm.quoteId,
                    memo: _this.deliverForm.memo,
                })
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '发货成功',
                            type: 'success'
                        });
                        _this.deliverDialogVisible = false;
                        _this.onSearch();

                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })



        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {

        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>

</style>